// extracted by mini-css-extract-plugin
export default {"approverDashboardContainer":"ApproverDashboard_approverDashboardContainer__LwIXi","approverDashboardBody":"ApproverDashboard_approverDashboardBody__2sZDS"};